import { __awaiter, __generator } from "tslib";
import { LocationService } from '../../../services/ProductLocation/LocationService';
export var getProductUrl = function (_a) {
    var context = _a.context;
    return function (slug) { return __awaiter(void 0, void 0, void 0, function () {
        var locationService;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new LocationService({ siteStore: context.siteStore }).init()];
                case 1:
                    locationService = _a.sent();
                    return [2 /*return*/, locationService.getProductUrl(slug)];
            }
        });
    }); };
};
//# sourceMappingURL=getProductUrl.js.map